import { Injectable } from "@angular/core";
import { RisrFormTypeExpander, RisrExpandableField, RisrSchemaField } from "@fry-it/risr-core";

/**
 * This expander is responsible for expanding user fields
 *
 * @category Forms
 * @example
 * ```typescript
 * const field = {
 *     id: 'id',
 *     label: 'Select users',
 *     expandType: 'user',
 *     required: true,
 *     initialValue: []
 * };
 * const expanded = await this.formExpander.expand(field);
 * ```
 */
@Injectable()
export class UserFieldExpander implements RisrFormTypeExpander {

    provideTypes: string[] = ['user'];
    async expand(field: RisrExpandableField): Promise<RisrSchemaField> {

        return {
            name: field.id,
            label: field.label,
            type: 'discrete_multiple',
            required: field.required,
            options: {
                extraCategories: [
                    { name: '__all__', label: 'All permissible users' },
                    { name: '__current__', label: 'Current user' },
                ],
                categoriesSource: '/users/stub'
            },
            initialValue: field.initialValue
        }
    }
}